const Stakely = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.02 87.02">
    <path
      d="m63.29 15.51-4.18 11.43c-8.27-4.5-19-5-21.46-1.33-2 2.95-1.64 7.67 6.27 10.19a1.49 1.49 0 0 1 .64 2.43l-5.49 6a5.93 5.93 0 0 1-7.17 1.23c-4.06-2.16-9.49-6.67-9.9-15.24-.77-18.12 21.44-23.28 41.29-14.71Z"
      style={{
        fillRule: "evenodd",
        fill: "#f79367",
      }}
    />
    <path
      d="M41.32 46.79a1.56 1.56 0 0 0 .6 2.53c4.27 1.57 10.59 4 9.27 9.68-1.56 6.75-17.3 4.88-26.26.73L21 71.08a49.74 49.74 0 0 0 31.74 3.19C70.46 70.11 65.86 52 64.29 48.69c-1.39-2.9-4.88-7.12-11.6-9.85a4.4 4.4 0 0 0-4.83 1Z"
      style={{
        fill: "#415876",
        fillRule: "evenodd",
      }}
    />
  </svg>
);

export default Stakely;
